import { Image } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { useScreenSizes } from 'src/utilities/useScreenSizes';

const BALANCE_MEAL_CREDITS_URL =
  'http://media-cdn.grubhub.com/grubhub-assets/image/upload/v1773311466/corp-management-ui/balance/Grubhub%20Phone%20Illustration_png.png';

export function MealCreditsImage(): JSX.Element {
  const { isPhone } = useScreenSizes();

  return (
    <Image
      width={isPhone ? '100' : '150'}
      src={BALANCE_MEAL_CREDITS_URL}
      alt="illustration"
      aria-label="Meal credits"
    />
  );
}
